import { createContext, useContext } from 'react';

import type { QpsActions, QpsContextState } from '@/types/qps';

const EMPTY_QPS_STATE: QpsContextState = { arbitrageId: null, questionnaires: [] };

// State and actions are split: the actions object is stable, the state changes on every answer.
const QpsStateContext = createContext<QpsContextState>(EMPTY_QPS_STATE);
const QpsActionsContext = createContext<QpsActions | undefined>(undefined);

const useQps = () => {
  const state = useContext(QpsStateContext);
  const actions = useContext(QpsActionsContext);

  if (!actions) {
    throw new Error('useQps must be used within a QpsProvider');
  }

  return {
    ...state,
    ...actions,
    getQuestionnaire: (codeSupport: string) =>
      state.questionnaires.find((questionnaire) => questionnaire.codeSupport === codeSupport),
  };
};

export { EMPTY_QPS_STATE, QpsActionsContext, QpsStateContext, useQps };
